import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgetPasswordVerifyCodeComponent } from './components/forget-password-verify-code/forget-password-verify-code.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';

const routes: Routes = [
  { path: "", component: ForgetPasswordComponent, data: { animation: 'ResetPassword' } },
  { path: "verify", component: ForgetPasswordVerifyCodeComponent, data: { animation: 'ResetPasswordVerify' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ForgetPasswordRoutingModule { }
